import { Button } from "@/components/ui/button";
import { ArrowRight, Shield, TrendingUp, Users } from "lucide-react";
import { Link } from "react-router-dom";
const Hero = () => {
  return <section className="relative bg-gradient-hero flex items-center py-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0 bg-white/5" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} />
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-8 py-[100px]">
        <div className="text-center">
          {/* Main Heading */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight">
          Bitcoin for Business
        </h1>
          
          {/* Subheading */}
          <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            Strengthen Your Business with Bitcoin Balance Sheet Strategy
          </p>
          
          {/* Description */}
          <p className="text-lg text-white/80 mb-12 max-w-4xl mx-auto leading-relaxed">
            Professional Bitcoin education and advisory services for business leaders, CFOs, and companies across all industries 
            looking to add Bitcoin to their balance sheets as a strategic asset. Get expert guidance on implementation, security, and compliance.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button variant="hero" size="lg" className="text-lg px-8 py-6" asChild>
              <Link to="/contact">
                Get Started Today <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button variant="outline-light" size="lg" className="text-lg px-8 py-6" asChild>
              <Link to="/services">
                Explore Services
              </Link>
            </Button>
          </div>
          
          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="flex flex-col items-center text-white/80">
              <Shield className="h-12 w-12 text-bitcoin-orange mb-4" />
              <h3 className="text-lg font-semibold mb-2">Secure Custody</h3>
              <p className="text-sm text-center">Professional-grade security solutions for corporate Bitcoin storage</p>
            </div>
            <div className="flex flex-col items-center text-white/80">
              <TrendingUp className="h-12 w-12 text-bitcoin-orange mb-4" />
              <h3 className="text-lg font-semibold mb-2">Balance Sheet Integration</h3>
              <p className="text-sm text-center">Strategic approaches for adding Bitcoin to your business balance sheet</p>
            </div>
            <div className="flex flex-col items-center text-white/80">
              <Users className="h-12 w-12 text-bitcoin-orange mb-4" />
              <h3 className="text-lg font-semibold mb-2">Expert Guidance</h3>
              <p className="text-sm text-center">Dedicated support for business leaders across all industries</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;